<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#63028F" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{msg}}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color:white;">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md10 lg8 xl6 text-left>
        <v-layout pt-6 wrap justify-center>
          <v-flex xs6>
            <v-btn text block light class="text-capitalize" disabled>
              <span style="font-family:poppinssemibold;font-size:18px;color:#000">Log In</span>
            </v-btn>
            <v-progress-linear value="100" color="#63028F"></v-progress-linear>
          </v-flex>
        </v-layout>
        <!-- <v-layout pt-6 wrap justify-center>
          <v-flex px-2 xs6 lg4>
            <v-btn outlined block light color="#f1f1f1">
              <span style="font-family:poppinssemibold;font-size:14px;color:#000">CUSTOMER</span>
            </v-btn>
          </v-flex>
          <v-flex px-2 xs6 lg4>
            <v-btn outlined block light color="#f1f1f1">
              <span style="font-family:poppinssemibold;font-size:14px;color:#000">SELLER</span>
            </v-btn>
          </v-flex>
        </v-layout>-->
        <v-layout pt-12 wrap justify-center>
          <v-flex px-2 xs12 text-center>
            <span style="font-family:poppinsmedium;font-size:25px;color:#000">Verify Phone</span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex px-2 xs12 text-center>
            <span style="font-family:poppinslight;font-size:15px;color:#7B7B7B">Code is sent to</span>
            <span style="font-family:poppinsregular;font-size:15px;color:#393C4A">+91 {{phone}}</span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex xs12 sm12 md11 lg10 xl9 pt-4 text-center>
            <vie-otp-input
              inputClasses="otp-input"
              :numInputs="6"
              separator
              :shouldAutoFocus="true"
              @on-complete="validateOTP"
            />
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12 pt-4 text-center>
            <span
              style="font-family:poppinslight;font-size:15px;color:#7B7B7B"
            >Didn't receive code? &nbsp;</span>

            <span
              v-if="!otpexpired"
              style="font-family:poppinsmedium;font-size:15px;color:#393C4A;"
            >Please Wait {{ timeLeft }}</span>
            <span
              v-if="otpexpired"
              style="font-family:poppinsmedium;font-size:15px;color:#393C4A;cursor:pointer"
              @click="sentOTP"
            >Request again</span>
          </v-flex>
        </v-layout>

        <v-layout v-if="msg2" py-4 wrap>
          <v-flex text-center>
            <span style="font-family:poppinslight;font-size:14px;color:red">{{msg2}}</span>
          </v-flex>
        </v-layout>
        <v-layout pt-4 wrap justify-end>
          <!-- <v-flex xs12 md8 pt-4 text-left>
            <span style="font-family:poppinsregular;font-size:14px;color:#7B7B7B">Forgot Password ?</span>
          </v-flex>-->
          <v-flex xs12 md4 pt-4 text-right>
            <v-btn
              block
              dark
              color="#63028F"
              depressed
              class="text-capitalize"
              @click="validateInput"
              :ripple="false"
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import VieOtpInput from "@bachdgvn/vue-otp-input";
import axios from "axios";
import store from "./../../store";
export default {
  components: {
    VieOtpInput,
  },
  props: ["pageData", "lastPage"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      msg2: null,
      phone: null,
      otp: null,
      timeLeft: "00:00",
      intervalTimer: null,
      otpexpired: false,
    };
  },
  beforeMount() {
    this.setTime(60);

    this.phone = this.pageData.phone;
  },
  methods: {
    validateOTP(value) {
      this.otp = value;
      this.validateInput();
    },
    validateInput() {
      this.login();
      // this.$emit("stepper", {
      //   winStep: 0,
      // });
    },
    login() {
      this.appLoading = true;
      var userData = {};
      userData["phone"] = this.pageData.phone;
      userData["otp"] = this.otp;
      axios({
        method: "POST",
        url: "/user/weblogin",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            store.commit("loginUser", true);
            localStorage.setItem("token", response.data.data.token);
            localStorage.setItem("pincode", response.data.data.pincode);
            // localStorage.setItem("userType", response.data.data.type);
            localStorage.setItem("userId", response.data.data.id);
            if (response.data.data.type == "Seller") {
              store.commit("userType", true);
            } else if (response.data.data.type == "Client") {
              store.commit("userType", false);
            }
            if (this.lastPage && response.data.data.type == "Client") {
              this.$router.push(this.lastPage.fullPath);
            } else if (response.data.data.type == "Seller") {
              if(response.data.data.status=="Pending")
               this.$router.push("/sellerRegistration");
               else
              this.$router.push("/myProducts");
            } else if (response.data.data.type == "Client") {
              this.$router.push("/");
            } else this.$router.push("/");
          } else {
            this.msg2 = response.data.msg;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    sentOTP() {
      var userData = {};
      userData["phone"] = this.pageData.phone;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/getsms",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.setTime(60);
            this.otpexpired = false;
            this.msg = "OTP Sent Successfully";
            this.showsnackbar = true;
          } else {
            this.msg = "Something Went Wrong";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    setTime(seconds) {
      clearInterval(this.intervalTimer);
      this.timer(seconds);
    },
    timer(seconds) {
      const now = Date.now();
      const end = now + seconds * 1000;
      this.displayTimeLeft(seconds);
      this.countdown(end);
    },
    countdown(end) {
      this.intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);
        if (secondsLeft == 0) this.otpexpired = true;
        if (secondsLeft < 0) {
          clearInterval(this.intervalTimer);
          return;
        }
        this.displayTimeLeft(secondsLeft);
      }, 1000);
    },
    displayTimeLeft(secondsLeft) {
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;
      var seconds1 = seconds;
      if (seconds < 10) seconds1 = "0" + seconds;
      this.timeLeft = "0" + minutes + " : " + seconds1;
    },
  },
};
</script>
<style scoped>
.separator {
  display: flex;
  align-items: center;
  text-align: center;
}
.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #c8c8c8;
}
.separator::before {
  margin-right: 0.25em;
}
.separator::after {
  margin-left: 0.25em;
}
</style>